// extracted by mini-css-extract-plugin
module.exports = {"actionBox":"actionBox___3FRhM"};